import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, Tooltip } from "reactstrap";
import "./MediaViewer.scss";
import { arrayMultimedia } from "../../../utils/types";

const MediaViewer = ({ show, toggle, multimediaFiles, index, withFooter,orientation }) => {
  const { t } = useTranslation(["media-viewer"]);
  const [tooltipDownload, setTooltipDownload] = useState(false);
  const [tooltipBack, setTooltipBack] = useState(false);
  const [activeFile, setActiveFile] = useState(0);
  const [multimedia, setMultimedia] = useState([{media: "",mediaType: "",mediaName: ""}]);
  const aRef = useRef(null);
  const download = () => {
    aRef.current.click();
  };
  useEffect(() => {
    setActiveFile(index ? index : 0);
  }, [index]);
  useEffect(() => {
    if (multimediaFiles) {
      let arr = multimediaFiles.map((file) => ({
        media: file.url,
        mediaType: file.mediaType,
        mediaName: orientation === 'left' ? file.url.split("/")[file.url.split("/").length - 1] : file.url.split("\\")[file.url.split("\\").length - 1],
      }));
      setMultimedia(arr);
    }
  }, [multimediaFiles]);

  const slide = (direction) => {
    setActiveFile(direction === "left" ? activeFile - 1 : activeFile + 1);
  };

  const {media,mediaType,mediaName} = multimedia ? multimedia[activeFile] : {media: "",mediaType: "",mediaName: ""}

  return (
    <Modal className={`uin-media-viewer ${withFooter ? 'footer': ''}`} isOpen={show} toggle={toggle} centered>
    	<a ref={aRef} href={media} download={mediaName} target='_blank' rel='noopener noreferrer' style={{ display: 'none' }}>
    		{mediaName}
    	</a>
    	<div className='uin-media-viewer__header'>
    		<div className='uin-media-viewer__back'>
    			<i id='uin-mv-icon-back' className='gcl-icon arrow' onClick={toggle} />
    			<Tooltip placement='bottom' isOpen={tooltipBack} target='uin-mv-icon-back' toggle={() => setTooltipBack(!tooltipBack)}>
    				{t('back')}
    			</Tooltip>
    		</div>
    		<div className='uin-media-viewer__name'>{mediaName}</div>
    		<div className='uin-media-viewer__download'>
    			<i id='uin-mv-icon-download' className='gcl-icon download' onClick={download} />
    			<Tooltip placement='bottom' isOpen={tooltipDownload} target='uin-mv-icon-download' toggle={() => setTooltipDownload(!tooltipDownload)}>
    				{t('download')}
    			</Tooltip>
    		</div>
    	</div>
    	<div className={`uin-media-viewer__content ${withFooter ? 'footer': ''}`}>
    		{withFooter && <div className={`uin-previus-miniature ${activeFile === 0 && 'disabled'}`}  >
    			<i className='gcl-icon clickable chevron-left' disabled={activeFile === 0} onClick={() => slide('left')}/>
    		</div>}
    		{media && (
    			<>
    				{mediaType === 'image' && <img src={media} alt={mediaName} onClick={download} />}
    				{mediaType === 'video' && <video preload='auto' autoPlay controls src={media} onClick={download} />}
    				{mediaType === 'audio' && <audio preload='auto' autoPlay controls src={media} onClick={download} />}
    			</>
    		)}
    		{withFooter && <div className={`uin-previus-miniature ${activeFile === (multimedia.length -1) && 'disabled'}`}>
    		<i className='gcl-icon clickable chevron-right' disabled={activeFile === (multimedia.length -1)} onClick={() => slide('right')}/>
    		</div>}
    	</div>
    	{withFooter &&
    		<div className='uin-media-viewer__footer'>
    			{multimedia && multimedia.map((v,i) =>(
    				<div key={i} className={`uin-miniaturs ${activeFile === i && 'active'}`} onClick={() => setActiveFile(i)} >
    					{
    						v.mediaType === 'image' ? <img src={v.media} ></img> :
    						v.mediaType === 'audio' ? <audio src={v.media} preload="metadata"></audio> :
    						v.mediaType === 'video' ? <video src={v.media} preload="metadata" /> :
    						<div>otro tipo</div>
    					}
    				</div>
    			))}
    		</div>
    	}
    </Modal>
  );
};

MediaViewer.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  multimediaFiles: PropTypes.arrayOf(arrayMultimedia).isRequired,
  index: PropTypes.number,
  withFooter: PropTypes.bool,
};
MediaViewer.defaultProps = {
  withFooter: false,
};

export default MediaViewer;
